const WithRender: React.FC<{ render: React.FC }> = ({ render, ...props }) => render(props);

export default WithRender;
